export default {
      id: "phone-usage",
      viewBox: "0 0 22 22",
      url: __webpack_public_path__ + "img/icons.svg#phone",
      toString: function () {
        return this.url;
      }
    }